"use client";

import { motion } from "framer-motion";

const fadeDown = {
  initial: { opacity: 0, y: -16 },
  animate: { opacity: 1, y: 0 },
};

function transition(delay: number) {
  return { duration: 0.6, ease: [0.16, 1, 0.3, 1] as const, delay };
}

export function AboutHero() {
  return (
    <section className="relative bg-primary-400/80 overflow-hidden">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-primary-300 opacity-30" />
        <div className="absolute -bottom-16 -left-16 w-72 h-72 rounded-full bg-primary-500 opacity-20" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-150 h-150 rounded-full border border-primary-200 opacity-20" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-95 h-95 rounded-full border border-primary-200 opacity-15" />
      </div>

      <div className="relative w-full max-w-8xl mx-auto px-6 sm:px-8 md:px-16 py-20 md:py-28 flex flex-col items-center gap-5 text-center">
        <motion.div
          {...fadeDown}
          transition={transition(0.1)}
          className="inline-flex items-center gap-2 bg-primary-300/40 border border-primary-200/60 rounded-full px-4 py-1.5 backdrop-blur-sm"
        >
          <span className="text-white text-xs font-semibold uppercase tracking-widest">
            Sobre o Clique Médicos
          </span>
        </motion.div>

        <motion.h1
          {...fadeDown}
          transition={transition(0.25)}
          className="text-4xl md:text-6xl font-bold text-white leading-tight"
        >
          Quem Somos?
        </motion.h1>

        <motion.p
          {...fadeDown}
          transition={transition(0.4)}
          className="text-primary-50 text-lg md:text-xl max-w-2xl leading-relaxed"
        >
          Uma plataforma da AMHP para aproximar você de profissionais e serviços
          de saúde no Distrito Federal.
        </motion.p>
      </div>

      <div
        className="absolute bottom-0 left-0 right-0 h-12 bg-background"
        style={{ clipPath: "ellipse(55% 100% at 50% 100%)" }}
      />
    </section>
  );
}
